export default __webpack_public_path__ + "static/media/guide1.c780081b.webp";